
import ContentFooter from "@/components/ContentFooter.vue";
import AppLayout from "@/layouts/AppLayout.vue";
import { Component, Vue } from "vue-property-decorator";
import { Action } from "vuex-class";
import CourseItem from "@/components/CourseItem.vue";

@Component({
  components: {
    AppLayout,
    ContentFooter,
    CourseItem,
  },
})
export default class InstructorDetail extends Vue {
  @Action("getInstructorDetail", { namespace: "instructor" })
  private getInstructorDetail: any;

  private instructor: any = null;
  private courses: any[] = [];

  private created() {
    const instructorId = this.$route.params.id;
    this.getInstructorDetail({
      params: {
        id: instructorId,
      },
      success: (response: any) => {
        this.instructor = response.data.data.instructor;
        this.courses = response.data.data.courses;
      },
    });
  }
}
